(function(){
  const sectionSelector = '[id^="kickback-"]';
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  // 1) Optional Vimeo background
  const vimeoURL = section.dataset.video && section.dataset.video.trim();
  if (vimeoURL) {
    const holder = section.querySelector('.kickback__video');
    if (holder) {
      const vidIdMatch = vimeoURL.match(/vimeo\.com\/(\d+)/i);
      if (vidIdMatch) {
        const id = vidIdMatch[1];
        const params = 'background=1&autoplay=1&muted=1&loop=1&title=0&byline=0&portrait=0&controls=0';
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${id}?${params}`;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.style.position = 'absolute';
        iframe.style.inset = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        holder.appendChild(iframe);
        holder.hidden = false;

        // Hide static bg image when video loads
        iframe.addEventListener('load', () => {
          const bg = section.querySelector('.kickback__bg');
          if (bg) bg.style.opacity = '0';
        });
      }
    }
  }

  // 2) Light parallax on mousemove (disabled if reduced motion)
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReduced) {
    const left = section.querySelector('.product-left');
    const right = section.querySelector('.product-right');
    const fruits = section.querySelectorAll('.floating-fruit');

    section.addEventListener('mousemove', (e) => {
      const rect = section.getBoundingClientRect();
      const cx = (e.clientX - rect.left) / rect.width - 0.5; // -0.5..0.5
      const cy = (e.clientY - rect.top) / rect.height - 0.5;
      const strength = 8;

      if (left)  left.style.transform  = `translate(${ -cx*strength }px, ${ -cy*strength }px) rotate(-8deg)`;
      if (right) right.style.transform = `translate(${  cx*strength }px, ${  cy*strength }px) rotate(8deg)`;
      fruits.forEach((f, i) => {
        const s = (i % 3 + 1) * 1.5;
        f.style.transform = `translate(${ cx*s }px, ${ cy*s }px)`;
      });
    });

    section.addEventListener('mouseleave', () => {
      if (left)  left.style.transform  = 'rotate(-8deg)';
      if (right) right.style.transform = 'rotate(8deg)';
      fruits.forEach((f) => { f.style.transform = ''; });
    });
  }
})();
